import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonGroup,
  Text,
  Modal,
} from '../../components';

const propTypes = {
  closeHandler: PropTypes.func.isRequired,
  deleteError: PropTypes.string,
  deleteHandler: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  planName: PropTypes.string,
};

const defaultProps = {
  deleteError: null,
  planName: 'this plan',
};

export default function DeletePlan({
  isOpen,
  deleteHandler,
  planName,
  closeHandler,
  deleteError,
}) {
  return (
    <Modal title="Delete Plan" isOpen={isOpen} onClose={closeHandler}>
      <Modal.Body>
        <Text as="h5">
          {`Are you sure you want to delete ${planName} permanently?`}
        </Text>
        {deleteError && <Text color="red">{deleteError}</Text>}
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button onClick={closeHandler}>Cancel</Button>
          <Button variant="danger" primary onClick={deleteHandler}>Delete</Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
}

DeletePlan.propTypes = propTypes;
DeletePlan.defaultProps = defaultProps;
